// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"76":"281c5f7f80033382c929","198":"2b8ad05b26b7d054c026","383":"2d8fea5cb5df7c018634"}[chunkId] + ".chunk.js";
};